import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { updateTimeRange } from 'custom_hooks/data_hooks/time_ranges/useTimeRange';
import { TimeRangeTableCellProps } from 'pages/Settings/TimeRanges/TimeRanges';

const errorMessage = 'Unable to save time range description.';

export function TimeRangeDescriptionCell({ rowData, onChange }: TimeRangeTableCellProps) {
    const onSave = async (newValue: string | undefined) => {
        if (!newValue) {
            return errorMessage;
        }
        try {
            await updateTimeRange(rowData, { Description: newValue });
            onChange();
        } catch {
            return errorMessage;
        }
        return undefined;
    };
    return (
        <TextInlineEditor
            ariaLabel={`${rowData.Name} tooltip description`}
            onConfirm={onSave}
            value={rowData.Description}
            validate={(v) => {
                if (!v || !v.trim()) {
                    return 'Time Range description is required';
                }
                if (v.length > 50) {
                    return 'Time Range description must be 50 characters or less';
                }
                return undefined;
            }}
        />
    );
}
